import React, { useCallback, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { CaretDown, CaretRight } from "phosphor-react";
import ZoningAccordionItem from "./components/ZoningAccordionItem";
import StackAccordionItem from "./components/StackAccordionItem";

const Accordion = ({ elements, removeItem }) => {
  const [orderItems, setOrderItems] = useState(null);
  const [clicked, setClicked] = useState(null);

  const handleToggle = (title) => {
    setClicked((prev) => (prev === title ? null : title));
  };

  const getSortedOrderItems = useCallback(() => {
    const zoningOrders = [];
    const stackOrders = [];
    const orders = [];
    elements.forEach((item) => {
      if (item.item_type === "zoning") {
        zoningOrders.push({
          type: item.item_type,
          data: {
            details: item.details,
            id: item.id,
            farm: item.farm,
            price: item.price,
            original_price: item.original_price,
          },
        });
      }
      if (item.item_type === "stack analysis order") {
        stackOrders.push({
          type: item.item_type,
          data: {
            details: item.details,
            id: item.id,
            farm: item.farm,
            price: item.price,
            original_price: item.original_price,
          },
        });
      }
    });
    orders.push({ zoning: zoningOrders, stack: stackOrders });
    setOrderItems(orders);
  }, [elements]);

  useEffect(() => {
    if (!elements) return;
    if (elements) {
      getSortedOrderItems();
    }
  }, [elements, getSortedOrderItems]);

  return (
    <div className="accordion">
      {orderItems && orderItems[0]?.zoning.length > 0 && (
        <div
          className={`accordion-item ${clicked === "zoning" ? "active" : ""}`}
        >
          <div
            className="accordion-header"
            onClick={() => handleToggle("zoning")}
            aria-hidden
          >
            <div className="accordion-title">Zoning Orders</div>
            <div>
              {clicked === "zoning" ? (
                <CaretDown size={20} />
              ) : (
                <CaretRight size={24} />
              )}
            </div>
          </div>
          <div
            className="item-body"
            style={
              clicked === "zoning" ? { height: "0px" } : { height: "208px" }
            }
          >
            {orderItems[0]?.zoning?.map((element) => (
              <ZoningAccordionItem item={element} removeItem={removeItem} />
            ))}
          </div>
        </div>
      )}
      {orderItems && orderItems[0]?.stack.length > 0 && (
        <div
          className={`accordion-item ${clicked === "stack" ? "active" : ""}`}
        >
          <div
            className="accordion-header"
            onClick={() => handleToggle("stack")}
            aria-hidden
          >
            <div className="accordion-title">Stack Analysis Orders</div>
            <div>
              {clicked === "stack" ? (
                <CaretDown size={20} />
              ) : (
                <CaretRight size={24} />
              )}
            </div>
          </div>
          <div
            className="item-body"
            style={
              clicked === "stack" ? { height: "0px" } : { height: "208px" }
            }
          >
            {orderItems[0]?.stack?.map((element) => (
              <StackAccordionItem item={element} removeItem={removeItem} />
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

Accordion.defaultProps = {
  elements: {},
  removeItem: () => {},
};

Accordion.propTypes = {
  elements: PropTypes.shape({
    id: PropTypes.string.isRequired,
    map: PropTypes.func.isRequired,
    forEach: PropTypes.func.isRequired,
  }),
  removeItem: PropTypes.func,
};

export default Accordion;
